import { GetFileReaderSync } from "@pdfking/capability"

// No FileReaderSync outside a worker, so the bytes come back the one other way
// the platform will hand them over without yielding: a synchronous XHR against
// an object URL, read as text that is not decoded and unpacked a byte at a
// time. Slow and ugly, and the only door there is.
const readDocument = (blob: Blob): ArrayBuffer => {
  const url = URL.createObjectURL(blob)
  try {
    const xhr = new XMLHttpRequest()
    xhr.open("GET", url, false)
    xhr.overrideMimeType("text/plain; charset=x-user-defined")
    xhr.send()
    const text = xhr.responseText
    const buf = new Uint8Array(text.length)
    for (let i = 0; i < text.length; i++) {
      buf[i] = text.charCodeAt(i) & 0xff
    }
    return buf.buffer
  } finally {
    URL.revokeObjectURL(url)
  }
}

/** A platform blob's bytes, without waiting for them.
 *
 * The one thing about a blob that a browser and node disagree on, and the
 * reason this package is split in two at all: everything else here either
 * holds its bytes already or is made of parts that do.
 *
 * Internal, and exported only because that is how the two versions of it are
 * told apart — the barrel picks one, and a relative import could not. What
 * callers want is `BlobArray`, which reaches this only when a part is the
 * platform's own blob and somebody asks for bytes without awaiting. */
export const BlobReadSync = (blob: Blob): ArrayBuffer => {
  const Reader = GetFileReaderSync()
  return Reader ? new Reader().readAsArrayBuffer(blob) : readDocument(blob)
}
